import { useState, useEffect } from 'react'

/**
 * delay the function with the given delay time
 * @param {*} inputValue
 * @param {*} delay
 * @returns
 */
const useDebounce = (inputValue, delay) => {
  const [debounceValue, setDebounceValue] = useState(inputValue)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(inputValue)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [inputValue, delay])

  return debounceValue
}

export default useDebounce
